/* DNA speed fix 11Oct26
   The theme's image-resize helper only understood .jpg/.png/.gif file names, so .webp product
   photos in "Recently viewed" and "Wishlist" were loaded at full original size (often 100-250 KB each).
   This version resizes any Shopify image (webp, jpg, png...) with Shopify's CDN width/height parameters. */
(function () {
  window.Shopify = window.Shopify || {};
  window.Shopify.resizeImage = function (src, size, crop) {
    if (!src) return src;
    try {
      var m = String(size || '').match(/(\d+)x(\d+)/);
      var abs = String(src).indexOf('//') === 0 ? 'https:' + src : String(src);
      var u = new URL(abs, window.location.origin);
      if (m) {
        u.searchParams.set('width', m[1]);
        u.searchParams.set('height', m[2]);
        if (crop) u.searchParams.set('crop', crop);
      }
      return u.toString();
    } catch (e) {
      return src;
    }
  };
})();
